export const orders = [
  {
    active: false,
    customerId: "",
    customerMail: "example@example.com",
    customerPhone: "12345678",
    isFromRegistered: false,
    orderBody: [
      {
        amount: 1,
        category: "MAIN",
        subcategory: "Burgers",
        name: "Special beef burger",
        serving: "400",
        price: 10,
        calories: 500,
        description: "Our very special burger",
        composition: "Beef, dough, milk, green salad",
        originalId: "5",
        _id: "5f1fbad6d6e4645f1dc20bb1"
      },
      {
        amount: 1,
        category: "SALAD",
        subcategory: "Meat salad",
        name: "Special beef salad",
        serving: "150",
        price: 4.5,
        calories: 200,
        description: "Beef, salad",
        composition: "",
        originalId: "1",
        _id: "5f1fbad6d6e4645f1dc20bb2"
      }
    ],
    orderDate: "2020-06-28T05:42:46.404Z",
    orderDateFormatted: "2020-06-28",
    orderDeliveryPrice: null,
    orderDiscounts: [],
    orderIsPaid: true,
    orderIsPaymentAllowed: true,
    orderNo: "0003",
    orderPaymentType: "online",
    orderStatus: "fulfilled",
    orderSum: 14.5,
    orderTakeDate: "1595914966328",
    orderTakeTime: "14:00",
    orderTakeType: "takeOut",
    orderTimeFormatted: "08:42:46",
    orderType: "dailymenuOrder",
    _id: "1"
  },
  {
    active: false,
    customerId: "",
    customerMail: "example@example.com",
    customerPhone: "12345678",
    isFromRegistered: false,
    orderBody: [
      {
        amount: 1,
        category: "MAIN",
        subcategory: "Burgers",
        name: "Special beef burger",
        serving: "400",
        price: 10,
        calories: 500,
        description: "Our very special burger",
        composition: "Beef, dough, milk, green salad",
        originalId: "5",
        _id: "5f1fbad6d6e4645f1dc20bb1"
      },
      {
        amount: 2,
        category: "SALAD",
        subcategory: "Meat salad",
        name: "Special beef salad",
        serving: "150",
        price: 4.5,
        calories: 200,
        description: "Beef, salad",
        composition: "",
        originalId: "1",
        _id: "5f1fbad6d6e4645f1dc20bb2"
      }
    ],
    orderDate: "2020-06-28T05:42:46.404Z",
    orderDateFormatted: "2020-06-20",
    orderDeliveryPrice: null,
    orderDiscounts: [],
    orderIsPaid: true,
    orderIsPaymentAllowed: true,
    orderNo: "0001",
    orderPaymentType: "online",
    orderStatus: "fulfilled",
    orderSum: 19,
    orderTakeDate: "1595914966328",
    orderTakeTime: "14:00",
    orderTakeType: "eatIn",
    orderTimeFormatted: "08:42:46",
    orderType: "dailymenuOrder",
    _id: "123"
  },
  {
    active: false,
    customerId: "",
    customerMail: "example@example.com",
    customerPhone: "12345678",
    isFromRegistered: false,
    orderBody: [
      {
        amount: 1,
        category: "MAIN",
        subcategory: "Burgers",
        name: "Special beef burger",
        serving: "400",
        price: 10,
        calories: 500,
        description: "Our very special burger",
        composition: "Beef, dough, milk, green salad",
        originalId: "5",
        _id: "5f1fbad6d6e4645f1dc20bb1"
      },
      {
        amount: 1,
        category: "SALAD",
        subcategory: "Meat salad",
        name: "Special beef salad",
        serving: "150",
        price: 4.5,
        calories: 200,
        description: "Beef, salad",
        composition: "",
        originalId: "1",
        _id: "5f1fbad6d6e4645f1dc20bb2"
      }
    ],
    orderDate: "2020-06-28T05:42:46.404Z",
    orderDateFormatted: "2020-07-29",
    orderDeliveryPrice: null,
    orderDiscounts: [],
    orderIsPaid: false,
    orderIsPaymentAllowed: true,
    orderNo: "0001",
    orderPaymentType: "online",
    orderStatus: "cancelled",
    orderSum: 14.5,
    orderTakeDate: "1595914966328",
    orderTakeTime: "14:00",
    orderTakeType: "takeOut",
    orderTimeFormatted: "08:42:46",
    orderType: "dailymenuOrder",
    _id: "567"
  },
  {
    active: true,
    customerId: "",
    customerMail: "example@example.com",
    customerPhone: "12345678",
    isFromRegistered: false,
    orderBody: [
      {
        amount: 1,
        category: "MAIN",
        subcategory: "Burgers",
        name: "Special beef burger",
        serving: "400",
        price: 10,
        calories: 500,
        description: "Our very special burger",
        composition: "Beef, dough, milk, green salad",
        originalId: "5",
        _id: "5f1fbad6d6e4645f1dc20bb1"
      },
      {
        amount: 1,
        category: "SALAD",
        subcategory: "Meat salad",
        name: "Special beef salad",
        serving: "150",
        price: 4.5,
        calories: 200,
        description: "Beef, salad",
        composition: "",
        originalId: "1",
        _id: "5f1fbad6d6e4645f1dc20bb2"
      },
      {
        amount: 1,
        category: "SIDE DISHES",
        subcategory: "Potatoes",
        name: "French fries",
        serving: "150",
        price: 3,
        calories: null,
        description: "",
        composition: "",
        originalId: "8",
        _id: "5f1fbad6d6e4645f1dc20bb3"
      }
    ],
    orderDate: "2020-07-28T05:42:46.404Z",
    orderDateFormatted: "2020-07-28",
    orderDeliveryPrice: null,
    orderDiscounts: [],
    orderIsPaid: true,
    orderIsPaymentAllowed: true,
    orderNo: "0005",
    orderPaymentType: "online",
    orderStatus: "requested",
    orderSum: 17.5,
    orderTakeDate: "1595914966328",
    orderTakeTime: "12:00",
    orderTakeType: "takeOut",
    orderTimeFormatted: "08:42:46",
    orderType: "dailymenuOrder",
    _id: "2"
  },
  {
    active: true,
    customerId: "",
    customerMail: "example2@example.com",
    customerPhone: "87654321",
    isFromRegistered: true,
    orderBody: [
      {
        amount: 1,
        category: "MAIN",
        subcategory: "Burgers",
        name: "Special beef burger",
        serving: "400",
        price: 10,
        calories: 500,
        description: "Our very special burger",
        composition: "Beef, dough, milk, green salad",
        originalId: "5",
        _id: "5f1fbad6d6e4645f1dc20bb1"
      },
      {
        amount: 2,
        category: "SALAD",
        subcategory: "Meat salad",
        name: "Special beef salad",
        serving: "150",
        price: 4.5,
        calories: 200,
        description: "Beef, salad",
        composition: "",
        originalId: "1",
        _id: "5f1fbad6d6e4645f1dc20bb2"
      }
    ],
    orderDate: "2020-07-28T05:42:46.404Z",
    orderDateFormatted: "2020-07-28",
    orderDeliveryPrice: 5,
    orderDiscounts: [],
    orderIsPaid: false,
    orderIsPaymentAllowed: false,
    orderNo: "0004",
    orderPaymentType: "online",
    orderStatus: "requested",
    orderSum: 24,
    orderTakeDate: "1595914966328",
    orderTakeTime: "14:00",
    orderTakeType: "delivery",
    orderDeliveryAddress: "Central av., 20",
    orderTimeFormatted: "09:42:46",
    orderType: "dailymenuOrder",
    _id: "41"
  },
  {
    active: true,
    customerId: "",
    customerMail: "example@example.com",
    customerPhone: "12345678",
    isFromRegistered: false,
    orderBody: [
      {
        amount: 2,
        category: "MAIN",
        subcategory: "Burgers",
        name: "Special beef burger",
        serving: "400",
        price: 10,
        calories: 500,
        description: "Our very special burger",
        composition: "Beef, dough, milk, green salad",
        originalId: "5",
        _id: "5f1fbad6d6e4645f1dc20bb1"
      },
      {
        amount: 2,
        category: "SALAD",
        subcategory: "Meat salad",
        name: "Special beef salad",
        serving: "150",
        price: 4.5,
        calories: 200,
        description: "Beef, salad",
        composition: "",
        originalId: "1",
        _id: "5f1fbad6d6e4645f1dc20bb2"
      },
      {
        amount: 1,
        category: "SIDE DISHES",
        subcategory: "Potatoes",
        name: "French fries",
        serving: "150",
        price: 3,
        calories: null,
        description: "",
        composition: "",
        originalId: "8",
        _id: "5f1fbad6d6e4645f1dc20bb3"
      }
    ],
    orderDate: "2020-07-28T05:42:46.404Z",
    orderDateFormatted: "2020-07-28",
    orderDeliveryPrice: null,
    orderDiscounts: [],
    orderIsPaid: false,
    orderIsPaymentAllowed: true,
    orderNo: "0003",
    orderPaymentType: "onSpot",
    orderStatus: "accepted",
    orderSum: 32,
    orderTakeDate: "1595914966328",
    orderTakeTime: "12:00",
    orderTakeType: "eatIn",
    orderTimeFormatted: "08:42:46",
    orderType: "dailymenuOrder",
    _id: "3"
  },
  {
    active: true,
    customerId: "",
    customerMail: "example@example.com",
    customerPhone: "12345678",
    isFromRegistered: false,
    orderBody: [
      {
        amount: 1,
        category: "MAIN",
        subcategory: "Burgers",
        name: "Special beef burger",
        serving: "400",
        price: 10,
        calories: 500,
        description: "Our very special burger",
        composition: "Beef, dough, milk, green salad",
        originalId: "5",
        _id: "5f1fbad6d6e4645f1dc20bb1"
      },
      {
        amount: 3,
        category: "SALAD",
        subcategory: "Meat salad",
        name: "Special beef salad",
        serving: "150",
        price: 4.5,
        calories: 200,
        description: "Beef, salad",
        composition: "",
        originalId: "1",
        _id: "5f1fbad6d6e4645f1dc20bb2"
      }
    ],
    orderDate: "2020-07-28T05:42:46.404Z",
    orderDateFormatted: "2020-07-28",
    orderDeliveryPrice: null,
    orderDiscounts: [],
    orderIsPaid: true,
    orderIsPaymentAllowed: true,
    orderNo: "0002",
    orderPaymentType: "online",
    orderStatus: "fulfilled",
    orderSum: 23.5,
    orderTakeDate: "1595914966328",
    orderTakeTime: "10:00",
    orderTakeType: "delivery",
    orderDeliveryAddress: "Sezame st., 90/210",
    orderTimeFormatted: "08:42:46",
    orderType: "dailymenuOrder",
    _id: "4"
  },
  {
    active: true,
    customerId: "",
    customerMail: "example@example.com",
    customerPhone: "12345678",
    isFromRegistered: false,
    orderBody: [
      {
        amount: 10,
        category: "DESSERTS",
        subcategory: "Ice cream",
        name: "Special vanilla ice cream",
        serving: "150",
        price: 10,
        calories: 500,
        description: "",
        composition: "",
        originalId: "12",
        _id: "5f1fbad6d6e4645f1dc20bb5"
      }
    ],
    orderDate: "2020-07-28T05:42:46.404Z",
    orderDateFormatted: "2020-07-28",
    orderDeliveryPrice: null,
    orderDiscounts: [],
    orderIsPaid: false,
    orderIsPaymentAllowed: true,
    orderNo: "0001",
    orderPaymentType: "online",
    orderStatus: "cancelled",
    orderSum: 100,
    orderTakeDate: "1595914966328",
    orderTakeTime: "12:00",
    orderTakeType: "takeOut",
    orderTimeFormatted: "08:42:46",
    orderType: "dailymenuOrder",
    _id: "5"
  }
];
